import { api } from './api';
import { getTenant, orgSearch } from '../helpers';
import { handleProgramMetadata } from './helpers';


export function getUserProgramsAPI(
  username: string,
  callback: (programs: any[]) => void,
  detailCallback?: (detail: any) => void,
): void {
  const tenant = getTenant();


  const fetchPrograms = (tenantKey: string): Promise<any[]> => {
    return new Promise<any[]>((resolve, reject) => {
      const requestData = {
        username,
        platform_key: tenantKey,
      };

      api.ibldmprograms.getUserPrograms(requestData, (response: any[]) => {
        if (!response || !Array.isArray(response)) {
          resolve([]);
        } else {
          resolve(response);

        }
      });
    });
  };

  if (tenant === 'main') {
    // If the tenant is "main", only fetch programs for "main"
    fetchPrograms(tenant)
      .then((programs) => {
        callback(programs);
        if (detailCallback) {
          handleProgramMetadata(programs, detailCallback);
        }
      })
      .catch(() => callback([]));
  } else {
    Promise.all([fetchPrograms(tenant), fetchPrograms('main')])
      .then((results) => {
        const aggregatedPrograms = [].concat(...results);
        callback(aggregatedPrograms);
        if (detailCallback) {
          handleProgramMetadata(aggregatedPrograms, detailCallback);
        }
      })
      .catch(() => callback([]));
  }
}

